import axios from "axios";
import { useAuthStore } from "@/stores/authStore";

export const signUp = async (data) => {
  try {
    const response = await axios.post("/api/User/UserRegister", data);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const signIn = async (data) => {
  const authStore = useAuthStore();
  try {
    const response = await axios.post("/api/User/UserLogin", data);
    if (response.data.Payload) {
      const { Token, RefreshToken, User } = response.data.Payload;

      authStore.setToken(Token);
      authStore.setRefreshToken(RefreshToken);
      authStore.setUser(User);
    }
    return response.data;
  } catch (error) {
    console.error("Login failed:", error);
  }
};

export const signOut = async () => {
  const authStore = useAuthStore();

  try {
    authStore.clearAuthData();
    return true;
  } catch (error) {
    console.error("Logout failed:", error);
    return false;
  }
};

export const refreshToken = async () => {
  const authStore = useAuthStore();
  try {
    const response = await axios.post("/api/User/RefreshToken", {
      refreshToken: authStore.refreshToken,
    });
    const { token, refreshToken } = response.data;

    authStore.setToken(token);
    authStore.setRefreshToken(refreshToken);

    return token;
  } catch (error) {
    console.error("Token yenileme hatası:", error);
    authStore.clearAuthData(); // Hata durumunda kullanıcı bilgilerini temizle
  }
};

export const requestPasswordReset = async (data) => {
  try {
    const response = await axios.post("/api/User/PasswordResetRequest", data);
    return response.data;
  } catch (error) {
    console.error("Password reset request failed:", error);
    throw error;
  }
};

export const resetPassword = async (data) => {
  try {
    const response = await axios.post("/api/User/PasswordReset", data);
    return response.data;
  } catch (error) {
    console.error("Password reset failed:", error);
    throw error;
  }
};
